<template lang="pug">
.text-end
  button.btn.btn-thin.me-3(@click='goToLogin')
    | {{ $t('button.login') }}
  button.btn.btn-primary(@click='goToCreateAccount')
    | {{ $t('button.createAccount') }}
</template>

<script>
import appConfig from '@/config';

export default {
  name: 'ButtonsLoginAndCreateAccount',
  methods: {
    goToCreateAccount() {
      window.location.assign(appConfig.registerPath);
    },
    goToLogin() {
      window.location.assign(appConfig.loginPath);
    },
  },
};
</script>
